<template>
  <v-layout>
    <v-main>
      <v-container>
        <v-card class="text-h6" style="padding: 1em !important">
          <v-sheet class="text-h4 ma-2 pa2">
            <v-row>
              <v-col class="d-flex justify-center mb-6">
                Joking Heroes — Aus Witzhelden
              </v-col>
            </v-row>
          </v-sheet>
          <v-row>
            <v-col>
              Unsere Cattery ist geboren aus der Liebe zu Maine Coons.<br />
              Seit unseren ersten Fellnasen in 2019 ist unser Rudel weiter gewachsen.<br />
              Die Entscheidung diese wundervollen Tiere zu züchten haben wir gemeinsam als Ehepaar getroffen:<br />
              <v-sheet class="mt-6">
                <v-row>
                  <v-col class="d-flex justify-center mb-6">
                    Joking Heroes im schönen Leichlingen Witzhelden entstand!
                  </v-col>
                </v-row>
              </v-sheet>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              Maine Coons sind wundervolle Tiere. <br />
              Voller Liebe, oft verschmust und geduldig mit Kindern, diese sanften Riesen haben unser Leben bereichert;
              und wir wünschen anderen genau so schöne Erfahrungen.
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              Mit unserer Zuchtlinie achten wir an erster Stelle auf gesunde und glückliche Tiere!<br />
              Jedes unserer Zuchttiere wird regelmäßig von Spezialist:innen untersucht, Deckkater aus anderen Catteries
              erfüllen immer die selben Anforderungen.
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              Wir achten auf ausdrucksvolle und authentische Linien!<br />
              Viele Linien haben andere Katzenrassen eingekreuzt, um ein gewünschtes Aussehen zu "erzüchten".<br />
              <b>Das lehnen wir ab.</b><br />
              Aus solchen Verkreuzungen entstehen oft Erbkrankheiten, die schwer vorherzusehen sind und die Tiere unnötig
              leiden lassen - nur um beispielsweise blaue Augen einzuzüchten.
            </v-col>
          </v-row>
          <v-sheet class="text-h5 pa-5">
            <v-row>
              <v-col class="d-flex justify-center mb-6">
                Woher kommt die Idee zur Zucht?
              </v-col>
            </v-row>
          </v-sheet>
          <v-row>
            <v-col>
              Jaqueline wollte schon immer Maine Coons, aber leider war es bis 2019 nicht möglich. Anfangs dachten wir
              auch, dass dieser Traum geplatzt ist, weil Niklas eine Allergie hätte.. Aber falsch gedacht, im Test kam
              raus: Hausstaub- und keine Katzenallergie!
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              Ab da schauten wir uns über Monate um und fanden unsere ersten beiden Fellpopos, die dann im März 2020
              einzogen. Schon bei der Besichtigung war klar, das sind unsere. Othello krabbelte im Laufstall auf
              Jaqueline's Fuß und Loki auf den von Niklas, anders als Schicksal konnte das nicht sein.
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              Natürlich sind Othello und Loki als Liebhabertiere eingezogen. Wir bekamen gerade während der Coronazeit so
              viel Liebe und steckten viel Zeit in das Training mit Klickern, ließen uns von den beiden Katzen erziehen
              und fanden unser Glück mit der Rasse.
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              Ein wenig später stellten wir fest, dass die beiden viel stritten und nicht ausgelastet waren und, da
              Othello schon so langsam richtung 8/9kg zielte, beschlossen wir einen weiteren Kater zu suchen. So fanden
              wir Conan (auch Liebhabertier), unseren absoluten roten Barbaren, der beim Kennenlernen einfach beschloss
              auf uns zu schlafen. :D
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              Loki nahm ihn an, als wäre es ihr Kitten und natürlich war die Freude groß, dass alles unkompliziert lief.
              Aber ein paar Monate später merkten wir, dass Othello so tiefenentspannt war wie noch nie und garkeine Lust
              hatte mehr mit Loki zu spielen. Er hat zwar seine Phasen, aber Loki war die streitlustige, die immer
              provozierte und mit Conan ihren absoluten Spielgefährten fand.
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              Wir erleben ständig neue Dinge, haben immer etwas zu Lachen und beschlossen, dass wir auch Kurse/Seminare
              machen möchten. Erst, damit wir alles besser verstehen und die Rasse auch genetisch und krankheitsbedingt
              näher kennenlernen.
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              Für uns kristallisierte sich der Wunsch diese unglaublich charakterstarke Rasse auch züchten zu wollen.
              Nicht einfach so, sondern mit viel Mühe und natürlich Diskussionen haben wir unsere Ziele gefunden.
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              Unser Augenmerk liegt auf der Gesundheit und eher moderaten/ alten Linien. Sprich nicht länger, höher,
              weiter, sondern eher Richtung feral. So wie die Maine Coon eigentlich war/ sein soll.
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              Als wir dann beschlossen nur ein wenig eine Richtung anzupeilen, was wir denn für eine erste Zuchtkatze
              hätten, stand fest, dass den ersten Schritt Jaqueline macht. Für sie stand fest, dass ihr Augenmerk (neben
              der Gesundheit) auf der Tabby-Zeichnung liegt und gerade diese so wenig in den Vordergrund gerückt wird.
              Gerade diese Zeichnung mit ihren wunderschönem Schneckenmuster hatte es ihr einfach angetan.
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            Wie es der Zufall so wollte, war gerade ein Wurf bei der Cattery Nova Scotia gelandet und wir wollten uns
            ein Mädchen anschauen. Vor Ort genau das, was man nicht möchte... Das Kitten hatte kein Interesse an uns und
            Jaqueline war auch nicht überzeugt, bis ein anderes Kitten sich den Weg auf ihr Knie erkämpfte und Jaqueline
            für sich beanspruchte. Zum Glück hatte die Kleine noch keinen festen Dosenöffner und hatte auch noch super
            Zuchtmerkmale und es war geschehen, so fanden wir unsere Sirona.
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            Sirona entpuppte sich als absoluter Sturrkopf, der schnell die Führung bei uns übernahm und für Besucher
            oder Spaziergänger mit ihrem black silver tabby classic ein Hingucker ist. Auch, wenn sie keine "Schoßkatze"
            ist, liegt sie ständig bei uns und holt sich ihre Liebe ab.
          </v-col>
        </v-row>
      </v-card>
    </v-container>
  </v-main>
</v-layout></template>

<script>
</script>
